import {
  FETCH_MOBILE_DEVICES_APPLICATION_REPORT,
  FETCH_MOBILE_DEVICES_SUMMARYCARD,
  DOWNLOAD_MOBILE_DEVICES_INSIGHTS,
  FETCH_MOBILE_DEVICES_REPORT,
  FETCH_MOBILE_DEVICES_NETWORK_REPORT
} from '../constants';


export const fetchMobileDevicesApplicationReport = () => ({
  type: FETCH_MOBILE_DEVICES_APPLICATION_REPORT,
});

export const downloadMobileDevices  = (csvType,reportType, fileName) => ({
  type: DOWNLOAD_MOBILE_DEVICES_INSIGHTS,
  csvType,
  reportType,
  fileName
});

export const  fetchMobileDevicesSummaryCard = () => ({
  type: FETCH_MOBILE_DEVICES_SUMMARYCARD,
});

export const fetchMobileDevicesReport = () => ({
  type: FETCH_MOBILE_DEVICES_REPORT,
});

export const fetchMobileDevicesNetwork = () => ({
  type: FETCH_MOBILE_DEVICES_NETWORK_REPORT,
});

